import authService from 'ApiService/Auth/AuthService';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import Centered from 'layouts/auth/types/Centered';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';

const OrgResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const Router = useNavigate();
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'password') {
      setPassword(value);
    } else if (name === 'confirmPassword') {
      setConfirmPassword(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!password || !confirmPassword) {
      toast.error('All fields are mandatory');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }

    try {
      const response = await authService.resetPassword(token, password);

      if (response.data.success) {
        toast.success(response.data.message);
        setPassword('');
        setConfirmPassword('');
        Router('/org-login');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 429) {
          toast.error('Too many requests from this IP, please try again later');
        } else if (error.response.status === 401) {
          toast.error(
            'Token expired. Please request a new password reset link.'
          );
          Router('/admin/forgot-password');
        } else {
          toast.error('Something went wrong. Please try again later.');
        }
      } else {
        toast.error('Something went wrong. Please try again later.');
      }
    }
  };

  return (
    <Centered
      bgImage="linear-gradient(135deg, #868CFF 100%, #4318FF 10%)"
      maincard={
        <Card extra="max-w-[405px] md:max-w-[510px] md:w-[510px] h-max mx-2.5 md:mx-auto mt-[50px] mb-auto py-2.5 px-4 md:!p-[50px] pt-8 md:pt-[50px]">
          <h3 className="mb-[10px] text-4xl font-bold text-gray-900 dark:text-white">
            Reset Password
          </h3>
          <p className="mb-9 ml-1 text-base text-gray-600">
            Enter your new password
          </p>
          <form onSubmit={handleSubmit}>
            <InputField
              variant="auth"
              extra="mb-3"
              label="New Password*"
              id="password"
              name="password"
              type="password"
              value={password}
              onChange={handleChange}
            />
            <InputField
              variant="auth"
              extra="mb-3"
              label="Confirm Password*"
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={handleChange}
            />
            <button
              type="submit"
              className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              Reset Password
            </button>
          </form>
        </Card>
      }
    />
  );
};

export default OrgResetPassword;
